// extracted by mini-css-extract-plugin
export default {"overlay":"OverlaySection_overlay__xVRRy","features":"OverlaySection_features__gBt6+"};